/**
 * Какой картой платили в прошлый раз. Способ оплаты прошлого заказа знает
 * сервер (`pay_method` в заказе), а номер карты в заказ не попадает — его
 * помним в браузере. Пропал — платим первой картой из списка.
 */
const KEY = 'dorixona.lastCardId'

export function lastCardId(): number {
  try {
    return Number(localStorage.getItem(KEY)) || 0
  } catch {
    return 0
  }
}

export function rememberCard(cardId: number): void {
  try {
    localStorage.setItem(KEY, String(cardId))
  } catch {
    // Не запомнилось — в следующий раз отметим первую карту.
  }
}
